module.exports = __webpack_public_path__ + "static/media/10.16623548.png";